import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const InvoiceOnlyRedirect = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const location = useLocation();
  
  // Check if user has invoice-only access
  const isInvoiceOnly = user?.invoice_only_access || false;
  const hasInvoiceAccess = user?.invoice_access || false;
  const isAdmin = user?.roles?.some((role: any) => role.name?.toLowerCase() === 'admin') || false;
  
  // If user has invoice-only access, redirect to invoices page
  if (isInvoiceOnly && hasInvoiceAccess && !isAdmin) {
    // Allow access to invoice-related routes and settings
    const allowedPaths = [
      '/accounting/invoices',
      '/accounting/payments', 
      '/accounting/overdue',
      '/accounting/reports',
      '/settings',
      '/notifications'
    ];
    
    const isAllowedPath = allowedPaths.some(path => location.pathname.startsWith(path));
    
    if (!isAllowedPath) {
      return <Navigate to="/accounting/invoices" replace />;
    }
  }
  
  return <>{children}</>;
};